export default "__VITE_ASSET__kaLmnSyo__"